export default __webpack_public_path__ + "c91575691ddbb98520533438979afb87.png";